export enum NotificationTypeEnum {
    LIVELAPSE_GENERATED = 'LIVELAPSE_GENERATED',
    LIVELAPSE_FAILED = 'LIVELAPSE_FAILED',
    MULTI_IMAGE_DOWNLOAD_GENERATED = 'MULTI_IMAGE_DOWNLOAD_GENERATED',
    MULTI_IMAGE_DOWNLOAD_FAILED = 'MULTI_IMAGE_DOWNLOAD_FAILED',
    SCHEDULED_CAMERA_PROGRESS_REPORT_GENERATED = 'SCHEDULED_CAMERA_PROGRESS_REPORT_GENERATED',
    PROGRESS_LINE_POST_CREATED = 'PROGRESS_LINE_POST_CREATED',
    PROGRESS_LINE_POST_TAGGED = 'PROGRESS_LINE_POST_TAGGED',
    PROGRESS_LINE_POST_COMMENT_CREATED = 'PROGRESS_LINE_POST_COMMENT_CREATED',
    PROGRESS_LINE_INTERACTED_POST_COMMENT_CREATED = 'PROGRESS_LINE_INTERACTED_POST_COMMENT_CREATED',
    PROGRESS_LINE_COMMENT_TAGGED = 'PROGRESS_LINE_COMMENT_TAGGED',
    CAMERA_IMAGE_COMMENT_CREATED = 'CAMERA_IMAGE_COMMENT_CREATED',
    CAMERA_IMAGE_COMMENT_TAGGED = 'CAMERA_IMAGE_COMMENT_TAGGED',
    CAMERA_IMAGE_COMMENT_REPLIED = 'CAMERA_IMAGE_COMMENT_REPLIED',
    CAMERA_IMAGE_COMMENT_REPLY_TAGGED = 'CAMERA_IMAGE_COMMENT_REPLY_TAGGED',
    PROJECT_CREATED = 'PROJECT_CREATED',
    CAMERA_CREATED = 'CAMERA_CREATED',
    PROJECT_ACCESS_GRANTED = 'PROJECT_ACCESS_GRANTED',
    PROJECT_ACCESS_REVOKED = 'PROJECT_ACCESS_REVOKED',
    SUPPORT_TICKET_REPLIED = 'SUPPORT_TICKET_REPLIED',
    USER_INVITATION_ACCEPTED = 'USER_INVITATION_ACCEPTED',
    USER_INVITATION_EXPIRED = 'USER_INVITATION_EXPIRED',
    USER_CREATED = 'USER_CREATED',
    DOCUMENT_FILE_ACCESS_GRANTED = 'DOCUMENT_FILE_ACCESS_GRANTED',
    DOCUMENT_FILE_ACCESS_REVOKED = 'DOCUMENT_FILE_ACCESS_REVOKED',
    DOCUMENT_EXTERNAL_LINK_ACCESS_GRANTED = 'DOCUMENT_EXTERNAL_LINK_ACCESS_GRANTED',
    DOCUMENT_EXTERNAL_LINK_ACCESS_REVOKED = 'DOCUMENT_EXTERNAL_LINK_ACCESS_REVOKED',
    DOCUMENT_ACCESS_GRANTED = 'DOCUMENT_ACCESS_GRANTED',
    DOCUMENT_ACCESS_REVOKED = 'DOCUMENT_ACCESS_REVOKED',
    SITE_WALK_FIELD_NOTE_CREATED = 'SITE_WALK_FIELD_NOTE_CREATED',
    SITE_WALK_FIELD_NOTE_TAGGED = 'SITE_WALK_FIELD_NOTE_TAGGED',
    SITE_WALK_FIELD_NOTE_REPLIED = 'SITE_WALK_FIELD_NOTE_REPLIED',
    SITE_WALK_FIELD_NOTE_CLOSED = 'SITE_WALK_FIELD_NOTE_CLOSED',
    SITE_WALK_FIELD_NOTE_REPLY_TAGGED = 'SITE_WALK_FIELD_NOTE_REPLY_TAGGED',
    SITE_WALK_UPLOADED = 'SITE_WALK_UPLOADED',
    CUSTOM_PUSH_NOTIFICATION = 'CUSTOM_PUSH_NOTIFICATION',
}
